var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6726 1.66809C12.5463 1.41208 12.2855 1.25 12.0001 1.25C11.7146 1.25 11.4538 1.41208 11.3275 1.66808L10.1743 4.00479L7.41742 4.31029C7.12103 4.34314 6.87226 4.54846 6.78379 4.83324C6.69533 5.11802 6.78398 5.42816 7.0096 5.62316L9.01426 7.35582L8.48528 9.84404C8.42485 10.1283 8.53404 10.4218 8.76551 10.5975C8.99698 10.7731 9.30909 10.7992 9.56655 10.6645L12.0001 9.39143L14.4335 10.6645C14.691 10.7992 15.0031 10.7731 15.2346 10.5975C15.466 10.4218 15.5752 10.1283 15.5148 9.84404L14.9858 7.35581L16.9905 5.62315C17.2161 5.42815 17.3047 5.11802 17.2163 4.83323C17.1278 4.54845 16.879 4.34314 16.5826 4.31029L13.8258 4.00479L12.6726 1.66809ZM10 12.2501C9.0335 12.2501 8.25 13.0336 8.25 14.0001V14.0155C8.1681 14.0053 8.08467 14 8 14H4C2.89543 14 2 14.8954 2 16V21C1.44772 21 1 21.4477 1 22C1 22.5523 1.44772 23 2 23H22C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21V18C22 16.8954 21.1046 16 20 16H16C15.9153 16 15.8319 16.0053 15.75 16.0155V14.0001C15.75 13.0336 14.9665 12.2501 14 12.2501H10ZM8 21H4V16H8V21ZM20 21H16V18H20V21Z",
    fill: "#FF9355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.97349046c830524e290ef5f82f28c926.svg";
export { ForwardRef as ReactComponent };